import App from '@components/sliders/SpaceSection.vue'
import { generateApplication } from '@helpers/generate_component.js';
import { generateAxiosInstance } from '@helpers/axios_provider.js';


const axios = generateAxiosInstance();
const injections = [{
    name: '$axios',
    module: generateAxiosInstance()
  }]
const props = { images: images }
generateApplication(App, "#space-section", { injections, props })